import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ViewHeader from 'components/rootComponents/Standards/ViewHeader/ViewHeader';
import SearchInput from 'components/rootComponents/Standards/SearchInput/SearchInput';
import axios from 'axios';
import { generateAndDownloadCsvContentList } from 'utils/helper';
import { IHeaders } from 'components/list/ListHeaders/ListHeaders.interface';
import { ICDPEmpleado } from '../CDP.interface';

/**
 * CDP Listado - Muestra los empleados activos con búsqueda y exportación.
 */
const CDPListado = (props: any) => {
  const [empleados, setEmpleados] = useState<ICDPEmpleado[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [search, setSearch] = useState<string>('');

  // ✅ Llamar a la API al montar el componente
  useEffect(() => {
    setLoading(true);
  
    axios
      .post<{ data?: { data?: { data?: ICDPEmpleado[] } } }>(
        'http://localhost:4000/v1.1/cdp/empleados_activos', 
        {}
      )
      .then((response) => {
        console.log("📌 Respuesta completa de la API:", response);
        console.log("📌 response.data:", JSON.stringify(response.data, null, 2));
  
        // ✅ Extraer correctamente el array de empleados
        const empleadosRecibidos = response.data?.data?.data?.data ?? [];
  
        console.log("✅ Datos asignados a empleados:", empleadosRecibidos);
        setEmpleados(empleadosRecibidos);
      })
      .catch((error) => {
        console.error('🚨 Error obteniendo empleados activos:', error);
        setEmpleados([]); // ✅ En caso de error, aseguramos un array vacío
      })
      .finally(() => setLoading(false));
  }, []);
  

  
  // ✅ Definir los encabezados de la tabla con los nombres correctos
  const headerCells: IHeaders[] = [
    { id: 'id', numeric: true, label: 'ID' },
    { id: 'codigo_funcionario', numeric: false, label: 'Código Funcionario' },
    { id: 'nombre_colaborador', numeric: false, label: 'Nombre' },
    { id: 'fecha_ingreso_utec', numeric: false, label: 'Fecha Ingreso' },
    { id: 'fecha_desvinculacion_utec', numeric: false, label: 'Fecha Desvinculación' },
    { id: 'estado_nomina', numeric: false, label: 'Estado' },
    { id: 'genero', numeric: false, label: 'Género' },
    { id: 'responsable', numeric: false, label: 'Supervisor' },
    { id: 'itr_empleado', numeric: false, label: 'ITR' },
    { id: 'sede_empleado', numeric: false, label: 'Ubicación' },
  ];

  // ✅ Filtrar empleados basados en la búsqueda
  const filteredEmpleados = Array.isArray(empleados) 
  ? empleados.filter((empleado) =>
      Object.values(empleado).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(search.toLowerCase())
      )
    )
  : [];


  console.log("📌 Empleados filtrados:", filteredEmpleados);

  // ✅ Mostrar un loading mientras se cargan los datos
  if (loading) {
    return (
      <Grid container spacing={2} justifyContent="center" style={{ marginTop: '20px' }}>
        <CircularProgress />
      </Grid>
    );
  }

  return (
    <Grid container spacing={2} style={{ marginTop: '20px', paddingLeft: '20px' }}>
      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
        <ViewHeader title="Empleados Activos - CDP" />
        <IconButton onClick={() => generateAndDownloadCsvContentList(headerCells, filteredEmpleados, 'Empleados Activos CDP')}>
          <DownloadIcon sx={{ color: '#007BFF' }} />
        </IconButton>
      </Grid>

      {/* ✅ Input de búsqueda */}
      <Grid item xs={12}>
        <SearchInput searchPlaceholder="Buscar empleado..." setSearchBar={setSearch} />
      </Grid>

      {/* ✅ Tabla de empleados */}
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                {headerCells.map((header) => (
                  <TableCell key={header.id}>{header.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredEmpleados.length > 0 ? (
                filteredEmpleados.map((empleado) => (
                  <TableRow key={empleado.id}>
                    <TableCell>{empleado.id}</TableCell>
                    <TableCell>{empleado.codigo_funcionario}</TableCell>
                    <TableCell>{empleado.nombre_colaborador}</TableCell>
                    <TableCell>
  {empleado.fecha_ingreso_utec 
    ? new Date(empleado.fecha_ingreso_utec).toLocaleDateString() 
    : '-'}
</TableCell>

                    <TableCell>{empleado.fecha_desvinculacion_utec || '-'}</TableCell>
                    <TableCell>{empleado.estado_nomina}</TableCell>
                    <TableCell>{empleado.genero}</TableCell>
                    <TableCell>{empleado.responsable}</TableCell>
                    <TableCell>{empleado.itr_empleado}</TableCell>
                    <TableCell>{empleado.sede_empleado}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={headerCells.length} style={{ textAlign: 'center' }}>
                    No se encontraron empleados
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

// ✅ Conectar con Redux si es necesario
const mapStateToProps = (state: any) => {
  return { filters: state.filters };
};

export default connect(mapStateToProps)(CDPListado);
